import * as angular from 'angular';

export interface IMediaQuery {
  desktopLG: number;
  desktop: number;
  tablet: number;
  mobile: number;
}

const value: IMediaQuery = {
  'desktopLG': 1200,
  'desktop': 992,
  'tablet': 768,
  'mobile': 480
};

export const READING_LOCATION_DUPLICATE_ERROR = 'reading_location_duplicate';

angular.module('app.common').constant('MEDIA_QUERY', value);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/constants.ts